import { useContext } from 'react'
import { GoogleReCaptchaContext } from './GoogleReCaptchaProvider'

// eslint-disable-next-line import/prefer-default-export
export const useGoogleReCaptcha = () => useContext(GoogleReCaptchaContext)
